import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import notificationApi from "./notificationApi";

export const getLatestNotifications = createThunkFromApi(
  "notification/getLatestNotifications",
  notificationApi.getLatestNotifications
);

export const notificationReadAll = createThunkFromApi(
  "notification/notificationReadAll",
  notificationApi.notificationReadAll
);

export const notificationRead = createThunkFromApi(
  "notification/notificationRead",
  notificationApi.notificationRead
);

export const getNotificationList = createThunkFromApi(
  "notification/getNotificationList",
  notificationApi.getNotificationList
);

const initialState = {
  notifications: null,
  latestNotifications: null,
  allNotifications: null,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,

  extraReducers: {
    [getLatestNotifications.fulfilled]: (state, { payload }) => {
      state.latestNotifications = payload.data;
    },
    [getNotificationList.fulfilled]: (state, { payload }) => {
      state.allNotifications = payload.data;
    },
  },
});

export const { setAllNotifications } = notificationSlice.actions;

export default notificationSlice.reducer;
